import { JobListResponse } from '@doda/api-client/aspida/@types';
import { FetchBaseStateType } from '@doda/common/src/interfaces/fetchBaseState';
import { createSlice } from '@reduxjs/toolkit';
import { LOADING_STATUS } from '@doda/common/src/constants/loadingStatus';
import { getJobListForTrendLanguageAndPositions } from '@doda/common/src/services/getJobListForTrendAPI';

type JobSearchListEntityType = FetchBaseStateType<JobListResponse>;

/**
 * 初期型
 * @param jobRecommendListForTrend 取得求人一覧
 * @param initialDisplayFlag 初期表示判定フラグ
 */
export interface JobRecommendListForTrendLanguageAndPositionsState {
  jobRecommendListForTrend: JobSearchListEntityType;
  initialDisplayFlag: number | null;
}

// 初期状態
export const jobRecommendListForTrendLanguageAndPositionsInitialState: JobRecommendListForTrendLanguageAndPositionsState =
  {
    jobRecommendListForTrend: {
      loading: LOADING_STATUS.IDLE,
      entity: { results: [] },
    },
    initialDisplayFlag: -1,
  };

export const jobRecommendListForTrendLanguageAndPositionsSlice = createSlice({
  name: 'jobRecommendListForTrendLanguageAndPositions',
  initialState: jobRecommendListForTrendLanguageAndPositionsInitialState,
  reducers: {
    setInitialDisplayFlagLanguageAndPositions: (state, action) => {
      state.initialDisplayFlag = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getJobListForTrendLanguageAndPositions.pending, (state) => {
      state.jobRecommendListForTrend.loading = LOADING_STATUS.PENDING;
    });
    builder.addCase(
      getJobListForTrendLanguageAndPositions.fulfilled,
      (state, action) => {
        state.jobRecommendListForTrend.loading = LOADING_STATUS.SUCCESS;
        state.jobRecommendListForTrend.entity = action.payload;
      }
    );
    builder.addCase(
      getJobListForTrendLanguageAndPositions.rejected,
      (state) => {
        state.jobRecommendListForTrend.loading = LOADING_STATUS.ERROR;
      }
    );
  },
});

// Create Action
export const { setInitialDisplayFlagLanguageAndPositions } =
  jobRecommendListForTrendLanguageAndPositionsSlice.actions;

// reducer
export const jobRecommendListForTrendLanguageAndPositionsReducer =
  jobRecommendListForTrendLanguageAndPositionsSlice.reducer;

interface State {
  jobRecommendListForTrendLanguageAndPositions: JobRecommendListForTrendLanguageAndPositionsState;
}

/**
 * ローディングSelector
 * @param state
 * @returns 状態
 */
export const jobRecommendListForTrendLanguageAndPositionsLoadingSelector = <
  S extends State,
>(
  state: S
) =>
  state.jobRecommendListForTrendLanguageAndPositions?.jobRecommendListForTrend
    .loading;

/**
 * 求人一覧Selector
 * @param state
 * @returns 求人一覧
 */
export const jobRecommendListForTrendLanguageAndPositionsEntitySelector = <
  S extends State,
>(
  state: S
) =>
  state.jobRecommendListForTrendLanguageAndPositions?.jobRecommendListForTrend
    .entity;

/**
 * 初期表示判定フラグSelector
 * @param state
 * @returns 初期表示判定フラグ
 */
export const initialDisplayFlagLanguageAndPositionsSelector = <S extends State>(
  state: S
) => state.jobRecommendListForTrendLanguageAndPositions.initialDisplayFlag;
